import { PrescricaoParmDTO } from "@/interfaces/prescription";
import { from, Observable } from "rxjs";
import { apiClient } from "./api";
import { ENDPOINTS } from "@/settings/api-settings";
import { map } from "rxjs/operators";

export function savePrescriptionDraft(parm: PrescricaoParmDTO): Observable<any> {
  return from(apiClient.post(ENDPOINTS.PRESCRIPTION_DRAFT, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function updatePrescriptionDraft(id: string, parm: PrescricaoParmDTO): Observable<any> {
  return from(apiClient.put(`${ENDPOINTS.PRESCRIPTION_DRAFT}/${id}`, parm)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function listPrescriptionsDrafts(): Observable<any> {
  return from(apiClient.get(ENDPOINTS.PRESCRIPTION_DRAFT)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function getPrescriptionDraft(id: string): Observable<any> {
  return from(apiClient.get(`${ENDPOINTS.PRESCRIPTION_DRAFT}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}

export function deletePrescriptionDraft(id: string): Observable<any> {
  return from(apiClient.delete(`${ENDPOINTS.PRESCRIPTION_DRAFT}/${id}`)).pipe(
    map((r: any) => {
      return !!r && r.data ? r.data : {};
    }),
  );
}